$(document).ready(function () {

	$('.zgloslicznik--liczniki--wrap').on('click', '.click_addLicznikGlowny', function() {
		var _this = $(this);
		var div_parent = _this.closest('.zgloslicznik--one');
		var number = div_parent.data('number');
		console.log(number)

		axios.post('/licznik/add-licznik-glowny', {
			number:number,
		}).then(function(res) {
			console.log(res)
			$('.zgloslicznik--liczniki--wrap').append(res.data.view)
			_this.closest('.dodaj--wrap--hand').addClass('dodaj--wrap--hidden')
			setAllLicznikGlowny(res.data.number);
		});
	})

	$('.zgloslicznik--liczniki--wrap').on('click', '.click_usunLicznikGlowny', function() {
		var div_parent = $(this).closest('.zgloslicznik--one');
		var number = div_parent.data('number');
		$(this).closest('.zgloslicznik--liczniki').remove();

		number = number - 1;
		$('.zgloslicznik--one[data-number="'+number+'"]').find('.dodaj--wrap--hand').removeClass('dodaj--wrap--hidden');

		setAllLicznikGlowny(number);
	})


	$('.zgloslicznik--liczniki--wrap').on('click', '.click_addPodlicznik', function() {
		var div_parent = $(this).closest('.zgloslicznik--one');
		var number = div_parent.data('number');
		var count_podlicznik = div_parent.data('count_podlicznik');
		console.log(number)
		console.log(count_podlicznik)

		axios.post('/licznik/add-podlicznik', {
			number:number,
			count_podlicznik:count_podlicznik,
		}).then(function(res) {
			console.log(res)
			console.log(number)
			
			div_parent.data('count_podlicznik', res.data.count_podlicznik);
			div_parent.find('.lista_podlicznikow').append(res.data.view);

			setAllPodlicznik(number, res.data.count_podlicznik);
		});
	})

	$('.zgloslicznik--liczniki--wrap').on('click', '.click_usunPodlicznik', function() {
		var div_parent = $(this).closest('.zgloslicznik--one');
		var count_podlicznik = div_parent.data('count_podlicznik');
		var number = div_parent.data('number');

		console.log(number)
		console.log(count_podlicznik)
		if (count_podlicznik <= 1) {
			return;
		} 
		
		div_parent.find('.zgloslicznik--hand_'+number+'_'+count_podlicznik).remove();
		count_podlicznik = count_podlicznik - 1;
		div_parent.data('count_podlicznik', count_podlicznik);
		
		setAllPodlicznik(number, count_podlicznik);
	})

});

function setAllLicznikGlowny(count_licznikGlowny) {
	$('#count_licznikGlowny').val(count_licznikGlowny);
}
function setAllPodlicznik(number, count_podlicznik) {
	$('input[name="count_podlicznik_'+number+'"]').val(count_podlicznik);
}